import { memo } from "react";

import { useRequiredContext } from "@redotech/react-util/context";
import CursorClickIcon from "@redotech/redo-icons/cursor-click-01.svg";
import CursorClickIconFilled from "@redotech/redo-icons/cursor-click-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { useMatch } from "react-router-dom";

export type RecoverSubRoute = "analytics" | "conversation-log" | "welcome";

export const RecoverItems = memo(function RecoverItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const settings = team.settings;

  const recoverRoot = routes.recoverHref;

  const recoverEnabled = settings.recover?.enabled;

  const anyChildSelected = useMatch(`${recoverRoot}/*`);

  const primaryHref = recoverEnabled
    ? routes.getRecoverSubRoute("conversation-log")
    : routes.getRecoverSubRoute("welcome");

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: primaryHref }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={CursorClickIconFilled}
      friendlyName="Recover"
      id="recover"
      UnfilledIcon={CursorClickIcon}
    >
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getRecoverSubRoute("welcome") }}
        friendlyName="Welcome"
        hidden={recoverEnabled}
        id="welcome"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getRecoverSubRoute("conversation-log"),
        }}
        friendlyName="Conversation log"
        hidden={!recoverEnabled}
        id="conversation-log"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getRecoverSubRoute("analytics") }}
        friendlyName="Analytics"
        hidden={!recoverEnabled}
        id="analytics"
      />
    </RedoSecondaryNavItem>
  );
});
